import RaiseRequestIcon from '@cp/src/assets/icons/RaiseRequestIcon';
import { useEffect, useState } from 'react';
import RequestTitle from './RequestTitle';
import RequestTicket from './RequestTicket';
import styles from './index.module.scss';
import ReceiveRequestIcon from '@cp/src/assets/icons/ReceiveRequestIcon';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import SingleTicketDrawer from '../SingleTicketDrawer';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';

const TicketRequestsView = () => {
  const [isticketDrawerOpen, setIsticketDrawerOpen] = useState(false);

  const requestRaised = useSelector(
    (state: RootState) => state?.csaTicketing?.requestRaised?.tickets
  );
  const requestReceived = useSelector(
    (state: RootState) => state?.csaTicketing?.requestReceived?.tickets
  );
  const ticket = useSelector((state: RootState) => state?.csaTicketing?.ticket?.ticketDetails);
  const isLoading = useSelector((state: RootState) => state?.csaTicketing?.ticket?.isLoading);

  const toggleTicketDrawer = () => {
    setIsticketDrawerOpen(prev => !prev);
  };

  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_TASKS_LOAD_SUCCESSFUL, {
      ticketId: ticket.referenceId
    });
  }, []);

  return (
    <div className="flex-1 overflow-y-auto">
      {requestReceived?.length ? (
        <div className={styles.ticketsWrapper}>
          <RequestTitle title="My tasks" icon={<ReceiveRequestIcon />} />
          {requestReceived.map((ticket, index: number) => (
            <RequestTicket
              key={ticket?.referenceId}
              ticket={ticket}
              showDashedLine={index !== requestReceived?.length - 1}
              toggleTicketDrawer={toggleTicketDrawer}
              isReceivedTicket
            />
          ))}
        </div>
      ) : null}
      {requestRaised?.length && requestReceived?.length ? (
        <div className="h-2 bg-[var(--greyscale-content-6)]" />
      ) : null}
      {requestRaised?.length ? (
        <div className={styles.ticketsWrapper}>
          <RequestTitle title="FE's tasks" icon={<RaiseRequestIcon />} />
          {requestRaised.map((ticket, index: number) => (
            <RequestTicket
              key={ticket?.referenceId}
              ticket={ticket}
              showDashedLine={index !== requestRaised?.length - 1}
              toggleTicketDrawer={toggleTicketDrawer}
            />
          ))}
        </div>
      ) : null}
      <SingleTicketDrawer
        isOpen={isticketDrawerOpen}
        toggleDrawer={toggleTicketDrawer}
        ticket={ticket}
        isLoading={isLoading}
      />
    </div>
  );
};

export default TicketRequestsView;
